function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_i_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.3523 16.1972C28.6114 15.6667 28.7471 15.0746 28.7471 14.4577C28.7471 13.8881 28.6299 13.3536 28.4197 12.8664H28.4262C28.3281 12.6457 28.2179 12.4373 28.0834 12.241L28.0809 12.2372C27.6615 11.5957 27.4394 10.8432 27.4394 10.0783V10.066C27.4394 7.84547 25.6383 6.04436 23.4178 6.04436C23.1957 6.04436 22.986 5.94567 22.8626 5.76063C22.1348 4.74905 20.938 4.08289 19.5934 4.08289C18.2487 4.08289 17.0521 4.74905 16.3242 5.76063C16.2009 5.93334 15.9912 6.04436 15.7691 6.04436C15.7345 6.04437 15.6999 6.0448 15.6655 6.04568C13.4928 6.10069 11.7475 7.88012 11.7475 10.066V10.0783C11.7475 10.8432 11.5254 11.5957 11.106 12.2372L11.1032 12.2417C10.6855 12.8822 10.4399 13.6331 10.4399 14.4577C10.4399 15.0869 10.588 15.6667 10.8347 16.1972C10.9211 16.3699 10.9211 16.5796 10.8347 16.7523C10.588 17.2704 10.4399 17.8502 10.4399 18.4671C10.4399 20.6383 12.1917 22.39 14.3629 22.39H24.8241C26.9953 22.39 28.7471 20.6383 28.7471 18.4671C28.7471 17.8502 28.599 17.2704 28.3523 16.7523C28.266 16.5796 28.266 16.3699 28.3523 16.1972ZM13.4072 12.9395H13.3922L14.8534 15.8109C15.0037 19.2272 16.3369 15.8109 19.5934 15.8109C22.8499 15.8109 24.2699 19.6134 24.4202 16.1972L25.8049 12.2999C25.7394 10.7824 24.6397 10.6759 24.4202 10.6759H20.495C18.9449 10.6759 17.4824 9.91721 16.6073 8.63616C16.4573 8.42472 16.1448 8.46203 16.0448 8.69834L15.9448 8.93465C15.6698 9.61872 15.1448 10.1411 14.4947 10.4396C14.476 10.4458 14.4541 10.4551 14.4322 10.4645C14.4103 10.4738 14.3885 10.4831 14.3697 10.4893C14.0822 10.6386 13.4072 11.0863 13.3822 12.243L13.3947 12.6161L13.4072 12.9395Z",
  fill: "url(#paint0_linear_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.3523 16.1972C28.6114 15.6667 28.7471 15.0746 28.7471 14.4577C28.7471 13.8881 28.6299 13.3536 28.4197 12.8664H28.4262C28.3281 12.6457 28.2179 12.4373 28.0834 12.241L28.0809 12.2372C27.6615 11.5957 27.4394 10.8432 27.4394 10.0783V10.066C27.4394 7.84547 25.6383 6.04436 23.4178 6.04436C23.1957 6.04436 22.986 5.94567 22.8626 5.76063C22.1348 4.74905 20.938 4.08289 19.5934 4.08289C18.2487 4.08289 17.0521 4.74905 16.3242 5.76063C16.2009 5.93334 15.9912 6.04436 15.7691 6.04436C15.7345 6.04437 15.6999 6.0448 15.6655 6.04568C13.4928 6.10069 11.7475 7.88012 11.7475 10.066V10.0783C11.7475 10.8432 11.5254 11.5957 11.106 12.2372L11.1032 12.2417C10.6855 12.8822 10.4399 13.6331 10.4399 14.4577C10.4399 15.0869 10.588 15.6667 10.8347 16.1972C10.9211 16.3699 10.9211 16.5796 10.8347 16.7523C10.588 17.2704 10.4399 17.8502 10.4399 18.4671C10.4399 20.6383 12.1917 22.39 14.3629 22.39H24.8241C26.9953 22.39 28.7471 20.6383 28.7471 18.4671C28.7471 17.8502 28.599 17.2704 28.3523 16.7523C28.266 16.5796 28.266 16.3699 28.3523 16.1972ZM13.4072 12.9395H13.3922L14.8534 15.8109C15.0037 19.2272 16.3369 15.8109 19.5934 15.8109C22.8499 15.8109 24.2699 19.6134 24.4202 16.1972L25.8049 12.2999C25.7394 10.7824 24.6397 10.6759 24.4202 10.6759H20.495C18.9449 10.6759 17.4824 9.91721 16.6073 8.63616C16.4573 8.42472 16.1448 8.46203 16.0448 8.69834L15.9448 8.93465C15.6698 9.61872 15.1448 10.1411 14.4947 10.4396C14.476 10.4458 14.4541 10.4551 14.4322 10.4645C14.4103 10.4738 14.3885 10.4831 14.3697 10.4893C14.0822 10.6386 13.4072 11.0863 13.3822 12.243L13.3947 12.6161L13.4072 12.9395Z",
  fill: "url(#paint1_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.3523 16.1972C28.6114 15.6667 28.7471 15.0746 28.7471 14.4577C28.7471 13.8881 28.6299 13.3536 28.4197 12.8664H28.4262C28.3281 12.6457 28.2179 12.4373 28.0834 12.241L28.0809 12.2372C27.6615 11.5957 27.4394 10.8432 27.4394 10.0783V10.066C27.4394 7.84547 25.6383 6.04436 23.4178 6.04436C23.1957 6.04436 22.986 5.94567 22.8626 5.76063C22.1348 4.74905 20.938 4.08289 19.5934 4.08289C18.2487 4.08289 17.0521 4.74905 16.3242 5.76063C16.2009 5.93334 15.9912 6.04436 15.7691 6.04436C15.7345 6.04437 15.6999 6.0448 15.6655 6.04568C13.4928 6.10069 11.7475 7.88012 11.7475 10.066V10.0783C11.7475 10.8432 11.5254 11.5957 11.106 12.2372L11.1032 12.2417C10.6855 12.8822 10.4399 13.6331 10.4399 14.4577C10.4399 15.0869 10.588 15.6667 10.8347 16.1972C10.9211 16.3699 10.9211 16.5796 10.8347 16.7523C10.588 17.2704 10.4399 17.8502 10.4399 18.4671C10.4399 20.6383 12.1917 22.39 14.3629 22.39H24.8241C26.9953 22.39 28.7471 20.6383 28.7471 18.4671C28.7471 17.8502 28.599 17.2704 28.3523 16.7523C28.266 16.5796 28.266 16.3699 28.3523 16.1972ZM13.4072 12.9395H13.3922L14.8534 15.8109C15.0037 19.2272 16.3369 15.8109 19.5934 15.8109C22.8499 15.8109 24.2699 19.6134 24.4202 16.1972L25.8049 12.2999C25.7394 10.7824 24.6397 10.6759 24.4202 10.6759H20.495C18.9449 10.6759 17.4824 9.91721 16.6073 8.63616C16.4573 8.42472 16.1448 8.46203 16.0448 8.69834L15.9448 8.93465C15.6698 9.61872 15.1448 10.1411 14.4947 10.4396C14.476 10.4458 14.4541 10.4551 14.4322 10.4645C14.4103 10.4738 14.3885 10.4831 14.3697 10.4893C14.0822 10.6386 13.4072 11.0863 13.3822 12.243L13.3947 12.6161L13.4072 12.9395Z",
  fill: "url(#paint2_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.3523 16.1972C28.6114 15.6667 28.7471 15.0746 28.7471 14.4577C28.7471 13.8881 28.6299 13.3536 28.4197 12.8664H28.4262C28.3281 12.6457 28.2179 12.4373 28.0834 12.241L28.0809 12.2372C27.6615 11.5957 27.4394 10.8432 27.4394 10.0783V10.066C27.4394 7.84547 25.6383 6.04436 23.4178 6.04436C23.1957 6.04436 22.986 5.94567 22.8626 5.76063C22.1348 4.74905 20.938 4.08289 19.5934 4.08289C18.2487 4.08289 17.0521 4.74905 16.3242 5.76063C16.2009 5.93334 15.9912 6.04436 15.7691 6.04436C15.7345 6.04437 15.6999 6.0448 15.6655 6.04568C13.4928 6.10069 11.7475 7.88012 11.7475 10.066V10.0783C11.7475 10.8432 11.5254 11.5957 11.106 12.2372L11.1032 12.2417C10.6855 12.8822 10.4399 13.6331 10.4399 14.4577C10.4399 15.0869 10.588 15.6667 10.8347 16.1972C10.9211 16.3699 10.9211 16.5796 10.8347 16.7523C10.588 17.2704 10.4399 17.8502 10.4399 18.4671C10.4399 20.6383 12.1917 22.39 14.3629 22.39H24.8241C26.9953 22.39 28.7471 20.6383 28.7471 18.4671C28.7471 17.8502 28.599 17.2704 28.3523 16.7523C28.266 16.5796 28.266 16.3699 28.3523 16.1972ZM13.4072 12.9395H13.3922L14.8534 15.8109C15.0037 19.2272 16.3369 15.8109 19.5934 15.8109C22.8499 15.8109 24.2699 19.6134 24.4202 16.1972L25.8049 12.2999C25.7394 10.7824 24.6397 10.6759 24.4202 10.6759H20.495C18.9449 10.6759 17.4824 9.91721 16.6073 8.63616C16.4573 8.42472 16.1448 8.46203 16.0448 8.69834L15.9448 8.93465C15.6698 9.61872 15.1448 10.1411 14.4947 10.4396C14.476 10.4458 14.4541 10.4551 14.4322 10.4645C14.4103 10.4738 14.3885 10.4831 14.3697 10.4893C14.0822 10.6386 13.4072 11.0863 13.3822 12.243L13.3947 12.6161L13.4072 12.9395Z",
  fill: "url(#paint3_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.3523 16.1972C28.6114 15.6667 28.7471 15.0746 28.7471 14.4577C28.7471 13.8881 28.6299 13.3536 28.4197 12.8664H28.4262C28.3281 12.6457 28.2179 12.4373 28.0834 12.241L28.0809 12.2372C27.6615 11.5957 27.4394 10.8432 27.4394 10.0783V10.066C27.4394 7.84547 25.6383 6.04436 23.4178 6.04436C23.1957 6.04436 22.986 5.94567 22.8626 5.76063C22.1348 4.74905 20.938 4.08289 19.5934 4.08289C18.2487 4.08289 17.0521 4.74905 16.3242 5.76063C16.2009 5.93334 15.9912 6.04436 15.7691 6.04436C15.7345 6.04437 15.6999 6.0448 15.6655 6.04568C13.4928 6.10069 11.7475 7.88012 11.7475 10.066V10.0783C11.7475 10.8432 11.5254 11.5957 11.106 12.2372L11.1032 12.2417C10.6855 12.8822 10.4399 13.6331 10.4399 14.4577C10.4399 15.0869 10.588 15.6667 10.8347 16.1972C10.9211 16.3699 10.9211 16.5796 10.8347 16.7523C10.588 17.2704 10.4399 17.8502 10.4399 18.4671C10.4399 20.6383 12.1917 22.39 14.3629 22.39H24.8241C26.9953 22.39 28.7471 20.6383 28.7471 18.4671C28.7471 17.8502 28.599 17.2704 28.3523 16.7523C28.266 16.5796 28.266 16.3699 28.3523 16.1972ZM13.4072 12.9395H13.3922L14.8534 15.8109C15.0037 19.2272 16.3369 15.8109 19.5934 15.8109C22.8499 15.8109 24.2699 19.6134 24.4202 16.1972L25.8049 12.2999C25.7394 10.7824 24.6397 10.6759 24.4202 10.6759H20.495C18.9449 10.6759 17.4824 9.91721 16.6073 8.63616C16.4573 8.42472 16.1448 8.46203 16.0448 8.69834L15.9448 8.93465C15.6698 9.61872 15.1448 10.1411 14.4947 10.4396C14.476 10.4458 14.4541 10.4551 14.4322 10.4645C14.4103 10.4738 14.3885 10.4831 14.3697 10.4893C14.0822 10.6386 13.4072 11.0863 13.3822 12.243L13.3947 12.6161L13.4072 12.9395Z",
  fill: "url(#paint4_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.3523 16.1972C28.6114 15.6667 28.7471 15.0746 28.7471 14.4577C28.7471 13.8881 28.6299 13.3536 28.4197 12.8664H28.4262C28.3281 12.6457 28.2179 12.4373 28.0834 12.241L28.0809 12.2372C27.6615 11.5957 27.4394 10.8432 27.4394 10.0783V10.066C27.4394 7.84547 25.6383 6.04436 23.4178 6.04436C23.1957 6.04436 22.986 5.94567 22.8626 5.76063C22.1348 4.74905 20.938 4.08289 19.5934 4.08289C18.2487 4.08289 17.0521 4.74905 16.3242 5.76063C16.2009 5.93334 15.9912 6.04436 15.7691 6.04436C15.7345 6.04437 15.6999 6.0448 15.6655 6.04568C13.4928 6.10069 11.7475 7.88012 11.7475 10.066V10.0783C11.7475 10.8432 11.5254 11.5957 11.106 12.2372L11.1032 12.2417C10.6855 12.8822 10.4399 13.6331 10.4399 14.4577C10.4399 15.0869 10.588 15.6667 10.8347 16.1972C10.9211 16.3699 10.9211 16.5796 10.8347 16.7523C10.588 17.2704 10.4399 17.8502 10.4399 18.4671C10.4399 20.6383 12.1917 22.39 14.3629 22.39H24.8241C26.9953 22.39 28.7471 20.6383 28.7471 18.4671C28.7471 17.8502 28.599 17.2704 28.3523 16.7523C28.266 16.5796 28.266 16.3699 28.3523 16.1972ZM13.4072 12.9395H13.3922L14.8534 15.8109C15.0037 19.2272 16.3369 15.8109 19.5934 15.8109C22.8499 15.8109 24.2699 19.6134 24.4202 16.1972L25.8049 12.2999C25.7394 10.7824 24.6397 10.6759 24.4202 10.6759H20.495C18.9449 10.6759 17.4824 9.91721 16.6073 8.63616C16.4573 8.42472 16.1448 8.46203 16.0448 8.69834L15.9448 8.93465C15.6698 9.61872 15.1448 10.1411 14.4947 10.4396C14.476 10.4458 14.4541 10.4551 14.4322 10.4645C14.4103 10.4738 14.3885 10.4831 14.3697 10.4893C14.0822 10.6386 13.4072 11.0863 13.3822 12.243L13.3947 12.6161L13.4072 12.9395Z",
  fill: "url(#paint5_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.3523 16.1972C28.6114 15.6667 28.7471 15.0746 28.7471 14.4577C28.7471 13.8881 28.6299 13.3536 28.4197 12.8664H28.4262C28.3281 12.6457 28.2179 12.4373 28.0834 12.241L28.0809 12.2372C27.6615 11.5957 27.4394 10.8432 27.4394 10.0783V10.066C27.4394 7.84547 25.6383 6.04436 23.4178 6.04436C23.1957 6.04436 22.986 5.94567 22.8626 5.76063C22.1348 4.74905 20.938 4.08289 19.5934 4.08289C18.2487 4.08289 17.0521 4.74905 16.3242 5.76063C16.2009 5.93334 15.9912 6.04436 15.7691 6.04436C15.7345 6.04437 15.6999 6.0448 15.6655 6.04568C13.4928 6.10069 11.7475 7.88012 11.7475 10.066V10.0783C11.7475 10.8432 11.5254 11.5957 11.106 12.2372L11.1032 12.2417C10.6855 12.8822 10.4399 13.6331 10.4399 14.4577C10.4399 15.0869 10.588 15.6667 10.8347 16.1972C10.9211 16.3699 10.9211 16.5796 10.8347 16.7523C10.588 17.2704 10.4399 17.8502 10.4399 18.4671C10.4399 20.6383 12.1917 22.39 14.3629 22.39H24.8241C26.9953 22.39 28.7471 20.6383 28.7471 18.4671C28.7471 17.8502 28.599 17.2704 28.3523 16.7523C28.266 16.5796 28.266 16.3699 28.3523 16.1972ZM13.4072 12.9395H13.3922L14.8534 15.8109C15.0037 19.2272 16.3369 15.8109 19.5934 15.8109C22.8499 15.8109 24.2699 19.6134 24.4202 16.1972L25.8049 12.2999C25.7394 10.7824 24.6397 10.6759 24.4202 10.6759H20.495C18.9449 10.6759 17.4824 9.91721 16.6073 8.63616C16.4573 8.42472 16.1448 8.46203 16.0448 8.69834L15.9448 8.93465C15.6698 9.61872 15.1448 10.1411 14.4947 10.4396C14.476 10.4458 14.4541 10.4551 14.4322 10.4645C14.4103 10.4738 14.3885 10.4831 14.3697 10.4893C14.0822 10.6386 13.4072 11.0863 13.3822 12.243L13.3947 12.6161L13.4072 12.9395Z",
  fill: "url(#paint6_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.3523 16.1972C28.6114 15.6667 28.7471 15.0746 28.7471 14.4577C28.7471 13.8881 28.6299 13.3536 28.4197 12.8664H28.4262C28.3281 12.6457 28.2179 12.4373 28.0834 12.241L28.0809 12.2372C27.6615 11.5957 27.4394 10.8432 27.4394 10.0783V10.066C27.4394 7.84547 25.6383 6.04436 23.4178 6.04436C23.1957 6.04436 22.986 5.94567 22.8626 5.76063C22.1348 4.74905 20.938 4.08289 19.5934 4.08289C18.2487 4.08289 17.0521 4.74905 16.3242 5.76063C16.2009 5.93334 15.9912 6.04436 15.7691 6.04436C15.7345 6.04437 15.6999 6.0448 15.6655 6.04568C13.4928 6.10069 11.7475 7.88012 11.7475 10.066V10.0783C11.7475 10.8432 11.5254 11.5957 11.106 12.2372L11.1032 12.2417C10.6855 12.8822 10.4399 13.6331 10.4399 14.4577C10.4399 15.0869 10.588 15.6667 10.8347 16.1972C10.9211 16.3699 10.9211 16.5796 10.8347 16.7523C10.588 17.2704 10.4399 17.8502 10.4399 18.4671C10.4399 20.6383 12.1917 22.39 14.3629 22.39H24.8241C26.9953 22.39 28.7471 20.6383 28.7471 18.4671C28.7471 17.8502 28.599 17.2704 28.3523 16.7523C28.266 16.5796 28.266 16.3699 28.3523 16.1972ZM13.4072 12.9395H13.3922L14.8534 15.8109C15.0037 19.2272 16.3369 15.8109 19.5934 15.8109C22.8499 15.8109 24.2699 19.6134 24.4202 16.1972L25.8049 12.2999C25.7394 10.7824 24.6397 10.6759 24.4202 10.6759H20.495C18.9449 10.6759 17.4824 9.91721 16.6073 8.63616C16.4573 8.42472 16.1448 8.46203 16.0448 8.69834L15.9448 8.93465C15.6698 9.61872 15.1448 10.1411 14.4947 10.4396C14.476 10.4458 14.4541 10.4551 14.4322 10.4645C14.4103 10.4738 14.3885 10.4831 14.3697 10.4893C14.0822 10.6386 13.4072 11.0863 13.3822 12.243L13.3947 12.6161L13.4072 12.9395Z",
  fill: "url(#paint7_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.3523 16.1972C28.6114 15.6667 28.7471 15.0746 28.7471 14.4577C28.7471 13.8881 28.6299 13.3536 28.4197 12.8664H28.4262C28.3281 12.6457 28.2179 12.4373 28.0834 12.241L28.0809 12.2372C27.6615 11.5957 27.4394 10.8432 27.4394 10.0783V10.066C27.4394 7.84547 25.6383 6.04436 23.4178 6.04436C23.1957 6.04436 22.986 5.94567 22.8626 5.76063C22.1348 4.74905 20.938 4.08289 19.5934 4.08289C18.2487 4.08289 17.0521 4.74905 16.3242 5.76063C16.2009 5.93334 15.9912 6.04436 15.7691 6.04436C15.7345 6.04437 15.6999 6.0448 15.6655 6.04568C13.4928 6.10069 11.7475 7.88012 11.7475 10.066V10.0783C11.7475 10.8432 11.5254 11.5957 11.106 12.2372L11.1032 12.2417C10.6855 12.8822 10.4399 13.6331 10.4399 14.4577C10.4399 15.0869 10.588 15.6667 10.8347 16.1972C10.9211 16.3699 10.9211 16.5796 10.8347 16.7523C10.588 17.2704 10.4399 17.8502 10.4399 18.4671C10.4399 20.6383 12.1917 22.39 14.3629 22.39H24.8241C26.9953 22.39 28.7471 20.6383 28.7471 18.4671C28.7471 17.8502 28.599 17.2704 28.3523 16.7523C28.266 16.5796 28.266 16.3699 28.3523 16.1972ZM13.4072 12.9395H13.3922L14.8534 15.8109C15.0037 19.2272 16.3369 15.8109 19.5934 15.8109C22.8499 15.8109 24.2699 19.6134 24.4202 16.1972L25.8049 12.2999C25.7394 10.7824 24.6397 10.6759 24.4202 10.6759H20.495C18.9449 10.6759 17.4824 9.91721 16.6073 8.63616C16.4573 8.42472 16.1448 8.46203 16.0448 8.69834L15.9448 8.93465C15.6698 9.61872 15.1448 10.1411 14.4947 10.4396C14.476 10.4458 14.4541 10.4551 14.4322 10.4645C14.4103 10.4738 14.3885 10.4831 14.3697 10.4893C14.0822 10.6386 13.4072 11.0863 13.3822 12.243L13.3947 12.6161L13.4072 12.9395Z",
  fill: "url(#paint8_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.3523 16.1972C28.6114 15.6667 28.7471 15.0746 28.7471 14.4577C28.7471 13.8881 28.6299 13.3536 28.4197 12.8664H28.4262C28.3281 12.6457 28.2179 12.4373 28.0834 12.241L28.0809 12.2372C27.6615 11.5957 27.4394 10.8432 27.4394 10.0783V10.066C27.4394 7.84547 25.6383 6.04436 23.4178 6.04436C23.1957 6.04436 22.986 5.94567 22.8626 5.76063C22.1348 4.74905 20.938 4.08289 19.5934 4.08289C18.2487 4.08289 17.0521 4.74905 16.3242 5.76063C16.2009 5.93334 15.9912 6.04436 15.7691 6.04436C15.7345 6.04437 15.6999 6.0448 15.6655 6.04568C13.4928 6.10069 11.7475 7.88012 11.7475 10.066V10.0783C11.7475 10.8432 11.5254 11.5957 11.106 12.2372L11.1032 12.2417C10.6855 12.8822 10.4399 13.6331 10.4399 14.4577C10.4399 15.0869 10.588 15.6667 10.8347 16.1972C10.9211 16.3699 10.9211 16.5796 10.8347 16.7523C10.588 17.2704 10.4399 17.8502 10.4399 18.4671C10.4399 20.6383 12.1917 22.39 14.3629 22.39H24.8241C26.9953 22.39 28.7471 20.6383 28.7471 18.4671C28.7471 17.8502 28.599 17.2704 28.3523 16.7523C28.266 16.5796 28.266 16.3699 28.3523 16.1972ZM13.4072 12.9395H13.3922L14.8534 15.8109C15.0037 19.2272 16.3369 15.8109 19.5934 15.8109C22.8499 15.8109 24.2699 19.6134 24.4202 16.1972L25.8049 12.2999C25.7394 10.7824 24.6397 10.6759 24.4202 10.6759H20.495C18.9449 10.6759 17.4824 9.91721 16.6073 8.63616C16.4573 8.42472 16.1448 8.46203 16.0448 8.69834L15.9448 8.93465C15.6698 9.61872 15.1448 10.1411 14.4947 10.4396C14.476 10.4458 14.4541 10.4551 14.4322 10.4645C14.4103 10.4738 14.3885 10.4831 14.3697 10.4893C14.0822 10.6386 13.4072 11.0863 13.3822 12.243L13.3947 12.6161L13.4072 12.9395Z",
  fill: "url(#paint9_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.3523 16.1972C28.6114 15.6667 28.7471 15.0746 28.7471 14.4577C28.7471 13.8881 28.6299 13.3536 28.4197 12.8664H28.4262C28.3281 12.6457 28.2179 12.4373 28.0834 12.241L28.0809 12.2372C27.6615 11.5957 27.4394 10.8432 27.4394 10.0783V10.066C27.4394 7.84547 25.6383 6.04436 23.4178 6.04436C23.1957 6.04436 22.986 5.94567 22.8626 5.76063C22.1348 4.74905 20.938 4.08289 19.5934 4.08289C18.2487 4.08289 17.0521 4.74905 16.3242 5.76063C16.2009 5.93334 15.9912 6.04436 15.7691 6.04436C15.7345 6.04437 15.6999 6.0448 15.6655 6.04568C13.4928 6.10069 11.7475 7.88012 11.7475 10.066V10.0783C11.7475 10.8432 11.5254 11.5957 11.106 12.2372L11.1032 12.2417C10.6855 12.8822 10.4399 13.6331 10.4399 14.4577C10.4399 15.0869 10.588 15.6667 10.8347 16.1972C10.9211 16.3699 10.9211 16.5796 10.8347 16.7523C10.588 17.2704 10.4399 17.8502 10.4399 18.4671C10.4399 20.6383 12.1917 22.39 14.3629 22.39H24.8241C26.9953 22.39 28.7471 20.6383 28.7471 18.4671C28.7471 17.8502 28.599 17.2704 28.3523 16.7523C28.266 16.5796 28.266 16.3699 28.3523 16.1972ZM13.4072 12.9395H13.3922L14.8534 15.8109C15.0037 19.2272 16.3369 15.8109 19.5934 15.8109C22.8499 15.8109 24.2699 19.6134 24.4202 16.1972L25.8049 12.2999C25.7394 10.7824 24.6397 10.6759 24.4202 10.6759H20.495C18.9449 10.6759 17.4824 9.91721 16.6073 8.63616C16.4573 8.42472 16.1448 8.46203 16.0448 8.69834L15.9448 8.93465C15.6698 9.61872 15.1448 10.1411 14.4947 10.4396C14.476 10.4458 14.4541 10.4551 14.4322 10.4645C14.4103 10.4738 14.3885 10.4831 14.3697 10.4893C14.0822 10.6386 13.4072 11.0863 13.3822 12.243L13.3947 12.6161L13.4072 12.9395Z",
  fill: "url(#paint10_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.3523 16.1972C28.6114 15.6667 28.7471 15.0746 28.7471 14.4577C28.7471 13.8881 28.6299 13.3536 28.4197 12.8664H28.4262C28.3281 12.6457 28.2179 12.4373 28.0834 12.241L28.0809 12.2372C27.6615 11.5957 27.4394 10.8432 27.4394 10.0783V10.066C27.4394 7.84547 25.6383 6.04436 23.4178 6.04436C23.1957 6.04436 22.986 5.94567 22.8626 5.76063C22.1348 4.74905 20.938 4.08289 19.5934 4.08289C18.2487 4.08289 17.0521 4.74905 16.3242 5.76063C16.2009 5.93334 15.9912 6.04436 15.7691 6.04436C15.7345 6.04437 15.6999 6.0448 15.6655 6.04568C13.4928 6.10069 11.7475 7.88012 11.7475 10.066V10.0783C11.7475 10.8432 11.5254 11.5957 11.106 12.2372L11.1032 12.2417C10.6855 12.8822 10.4399 13.6331 10.4399 14.4577C10.4399 15.0869 10.588 15.6667 10.8347 16.1972C10.9211 16.3699 10.9211 16.5796 10.8347 16.7523C10.588 17.2704 10.4399 17.8502 10.4399 18.4671C10.4399 20.6383 12.1917 22.39 14.3629 22.39H24.8241C26.9953 22.39 28.7471 20.6383 28.7471 18.4671C28.7471 17.8502 28.599 17.2704 28.3523 16.7523C28.266 16.5796 28.266 16.3699 28.3523 16.1972ZM13.4072 12.9395H13.3922L14.8534 15.8109C15.0037 19.2272 16.3369 15.8109 19.5934 15.8109C22.8499 15.8109 24.2699 19.6134 24.4202 16.1972L25.8049 12.2999C25.7394 10.7824 24.6397 10.6759 24.4202 10.6759H20.495C18.9449 10.6759 17.4824 9.91721 16.6073 8.63616C16.4573 8.42472 16.1448 8.46203 16.0448 8.69834L15.9448 8.93465C15.6698 9.61872 15.1448 10.1411 14.4947 10.4396C14.476 10.4458 14.4541 10.4551 14.4322 10.4645C14.4103 10.4738 14.3885 10.4831 14.3697 10.4893C14.0822 10.6386 13.4072 11.0863 13.3822 12.243L13.3947 12.6161L13.4072 12.9395Z",
  fill: "url(#paint11_radial_4002_3860)"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.87352 9.27364C3.74853 7.35177 3.59228 6.31531 3.5454 5.63302C3.51021 5.12077 3.56884 4.56662 4.25634 4.44162C4.854 4.3674 5.13915 4.89344 5.16259 5.10177C5.15998 4.90125 5.16259 4.42224 5.16259 4.29709C5.16259 4.08615 5.1704 3.32052 6.02196 3.32052C6.62331 3.32052 6.83838 3.90776 6.82275 4.1838C6.83317 4.08224 6.84541 3.77052 6.85791 3.47677C6.87634 3.04347 7.10947 2.48771 7.80322 2.50021C8.40088 2.53927 8.59619 3.11349 8.56884 3.47677L8.45165 5.34396C8.47509 5.15646 8.554 4.67911 8.729 4.00411C8.904 3.32911 9.43058 3.28433 9.68602 3.32052C10.012 3.3667 10.5657 3.68146 10.3345 4.59396C10.0595 5.75021 9.87223 7.23849 9.80713 7.87911C10.1266 7.74822 10.412 7.4504 10.7642 7.08287L10.7798 7.06661C11.1392 6.69161 11.7134 6.73458 11.9516 6.96114C12.3149 7.19552 12.5142 7.89864 12.1118 8.30099C11.6493 8.72599 9.9829 10.7059 9.15477 11.6955C8.92561 11.9872 8.1579 12.5705 6.9204 12.5705C4.71727 12.4768 3.97894 10.8944 3.87352 9.27364Z",
  fill: "url(#paint12_radial_4002_3860)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.87352 9.27364C3.74853 7.35177 3.59228 6.31531 3.5454 5.63302C3.51021 5.12077 3.56884 4.56662 4.25634 4.44162C4.854 4.3674 5.13915 4.89344 5.16259 5.10177C5.15998 4.90125 5.16259 4.42224 5.16259 4.29709C5.16259 4.08615 5.1704 3.32052 6.02196 3.32052C6.62331 3.32052 6.83838 3.90776 6.82275 4.1838C6.83317 4.08224 6.84541 3.77052 6.85791 3.47677C6.87634 3.04347 7.10947 2.48771 7.80322 2.50021C8.40088 2.53927 8.59619 3.11349 8.56884 3.47677L8.45165 5.34396C8.47509 5.15646 8.554 4.67911 8.729 4.00411C8.904 3.32911 9.43058 3.28433 9.68602 3.32052C10.012 3.3667 10.5657 3.68146 10.3345 4.59396C10.0595 5.75021 9.87223 7.23849 9.80713 7.87911C10.1266 7.74822 10.412 7.4504 10.7642 7.08287L10.7798 7.06661C11.1392 6.69161 11.7134 6.73458 11.9516 6.96114C12.3149 7.19552 12.5142 7.89864 12.1118 8.30099C11.6493 8.72599 9.9829 10.7059 9.15477 11.6955C8.92561 11.9872 8.1579 12.5705 6.9204 12.5705C4.71727 12.4768 3.97894 10.8944 3.87352 9.27364Z",
  fill: "url(#paint13_radial_4002_3860)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.87352 9.27364C3.74853 7.35177 3.59228 6.31531 3.5454 5.63302C3.51021 5.12077 3.56884 4.56662 4.25634 4.44162C4.854 4.3674 5.13915 4.89344 5.16259 5.10177C5.15998 4.90125 5.16259 4.42224 5.16259 4.29709C5.16259 4.08615 5.1704 3.32052 6.02196 3.32052C6.62331 3.32052 6.83838 3.90776 6.82275 4.1838C6.83317 4.08224 6.84541 3.77052 6.85791 3.47677C6.87634 3.04347 7.10947 2.48771 7.80322 2.50021C8.40088 2.53927 8.59619 3.11349 8.56884 3.47677L8.45165 5.34396C8.47509 5.15646 8.554 4.67911 8.729 4.00411C8.904 3.32911 9.43058 3.28433 9.68602 3.32052C10.012 3.3667 10.5657 3.68146 10.3345 4.59396C10.0595 5.75021 9.87223 7.23849 9.80713 7.87911C10.1266 7.74822 10.412 7.4504 10.7642 7.08287L10.7798 7.06661C11.1392 6.69161 11.7134 6.73458 11.9516 6.96114C12.3149 7.19552 12.5142 7.89864 12.1118 8.30099C11.6493 8.72599 9.9829 10.7059 9.15477 11.6955C8.92561 11.9872 8.1579 12.5705 6.9204 12.5705C4.71727 12.4768 3.97894 10.8944 3.87352 9.27364Z",
  fill: "url(#paint14_linear_4002_3860)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M3.87352 9.27364C3.74853 7.35177 3.59228 6.31531 3.5454 5.63302C3.51021 5.12077 3.56884 4.56662 4.25634 4.44162C4.854 4.3674 5.13915 4.89344 5.16259 5.10177C5.15998 4.90125 5.16259 4.42224 5.16259 4.29709C5.16259 4.08615 5.1704 3.32052 6.02196 3.32052C6.62331 3.32052 6.83838 3.90776 6.82275 4.1838C6.83317 4.08224 6.84541 3.77052 6.85791 3.47677C6.87634 3.04347 7.10947 2.48771 7.80322 2.50021C8.40088 2.53927 8.59619 3.11349 8.56884 3.47677L8.45165 5.34396C8.47509 5.15646 8.554 4.67911 8.729 4.00411C8.904 3.32911 9.43058 3.28433 9.68602 3.32052C10.012 3.3667 10.5657 3.68146 10.3345 4.59396C10.0595 5.75021 9.87223 7.23849 9.80713 7.87911C10.1266 7.74822 10.412 7.4504 10.7642 7.08287L10.7798 7.06661C11.1392 6.69161 11.7134 6.73458 11.9516 6.96114C12.3149 7.19552 12.5142 7.89864 12.1118 8.30099C11.6493 8.72599 9.9829 10.7059 9.15477 11.6955C8.92561 11.9872 8.1579 12.5705 6.9204 12.5705C4.71727 12.4768 3.97894 10.8944 3.87352 9.27364Z",
  fill: "url(#paint15_radial_4002_3860)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M3.87352 9.27364C3.74853 7.35177 3.59228 6.31531 3.5454 5.63302C3.51021 5.12077 3.56884 4.56662 4.25634 4.44162C4.854 4.3674 5.13915 4.89344 5.16259 5.10177C5.15998 4.90125 5.16259 4.42224 5.16259 4.29709C5.16259 4.08615 5.1704 3.32052 6.02196 3.32052C6.62331 3.32052 6.83838 3.90776 6.82275 4.1838C6.83317 4.08224 6.84541 3.77052 6.85791 3.47677C6.87634 3.04347 7.10947 2.48771 7.80322 2.50021C8.40088 2.53927 8.59619 3.11349 8.56884 3.47677L8.45165 5.34396C8.47509 5.15646 8.554 4.67911 8.729 4.00411C8.904 3.32911 9.43058 3.28433 9.68602 3.32052C10.012 3.3667 10.5657 3.68146 10.3345 4.59396C10.0595 5.75021 9.87223 7.23849 9.80713 7.87911C10.1266 7.74822 10.412 7.4504 10.7642 7.08287L10.7798 7.06661C11.1392 6.69161 11.7134 6.73458 11.9516 6.96114C12.3149 7.19552 12.5142 7.89864 12.1118 8.30099C11.6493 8.72599 9.9829 10.7059 9.15477 11.6955C8.92561 11.9872 8.1579 12.5705 6.9204 12.5705C4.71727 12.4768 3.97894 10.8944 3.87352 9.27364Z",
  fill: "url(#paint16_radial_4002_3860)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M3.87352 9.27364C3.74853 7.35177 3.59228 6.31531 3.5454 5.63302C3.51021 5.12077 3.56884 4.56662 4.25634 4.44162C4.854 4.3674 5.13915 4.89344 5.16259 5.10177C5.15998 4.90125 5.16259 4.42224 5.16259 4.29709C5.16259 4.08615 5.1704 3.32052 6.02196 3.32052C6.62331 3.32052 6.83838 3.90776 6.82275 4.1838C6.83317 4.08224 6.84541 3.77052 6.85791 3.47677C6.87634 3.04347 7.10947 2.48771 7.80322 2.50021C8.40088 2.53927 8.59619 3.11349 8.56884 3.47677L8.45165 5.34396C8.47509 5.15646 8.554 4.67911 8.729 4.00411C8.904 3.32911 9.43058 3.28433 9.68602 3.32052C10.012 3.3667 10.5657 3.68146 10.3345 4.59396C10.0595 5.75021 9.87223 7.23849 9.80713 7.87911C10.1266 7.74822 10.412 7.4504 10.7642 7.08287L10.7798 7.06661C11.1392 6.69161 11.7134 6.73458 11.9516 6.96114C12.3149 7.19552 12.5142 7.89864 12.1118 8.30099C11.6493 8.72599 9.9829 10.7059 9.15477 11.6955C8.92561 11.9872 8.1579 12.5705 6.9204 12.5705C4.71727 12.4768 3.97894 10.8944 3.87352 9.27364Z",
  fill: "url(#paint17_radial_4002_3860)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M3.87352 9.27364C3.74853 7.35177 3.59228 6.31531 3.5454 5.63302C3.51021 5.12077 3.56884 4.56662 4.25634 4.44162C4.854 4.3674 5.13915 4.89344 5.16259 5.10177C5.15998 4.90125 5.16259 4.42224 5.16259 4.29709C5.16259 4.08615 5.1704 3.32052 6.02196 3.32052C6.62331 3.32052 6.83838 3.90776 6.82275 4.1838C6.83317 4.08224 6.84541 3.77052 6.85791 3.47677C6.87634 3.04347 7.10947 2.48771 7.80322 2.50021C8.40088 2.53927 8.59619 3.11349 8.56884 3.47677L8.45165 5.34396C8.47509 5.15646 8.554 4.67911 8.729 4.00411C8.904 3.32911 9.43058 3.28433 9.68602 3.32052C10.012 3.3667 10.5657 3.68146 10.3345 4.59396C10.0595 5.75021 9.87223 7.23849 9.80713 7.87911C10.1266 7.74822 10.412 7.4504 10.7642 7.08287L10.7798 7.06661C11.1392 6.69161 11.7134 6.73458 11.9516 6.96114C12.3149 7.19552 12.5142 7.89864 12.1118 8.30099C11.6493 8.72599 9.9829 10.7059 9.15477 11.6955C8.92561 11.9872 8.1579 12.5705 6.9204 12.5705C4.71727 12.4768 3.97894 10.8944 3.87352 9.27364Z",
  fill: "url(#paint18_radial_4002_3860)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M3.87352 9.27364C3.74853 7.35177 3.59228 6.31531 3.5454 5.63302C3.51021 5.12077 3.56884 4.56662 4.25634 4.44162C4.854 4.3674 5.13915 4.89344 5.16259 5.10177C5.15998 4.90125 5.16259 4.42224 5.16259 4.29709C5.16259 4.08615 5.1704 3.32052 6.02196 3.32052C6.62331 3.32052 6.83838 3.90776 6.82275 4.1838C6.83317 4.08224 6.84541 3.77052 6.85791 3.47677C6.87634 3.04347 7.10947 2.48771 7.80322 2.50021C8.40088 2.53927 8.59619 3.11349 8.56884 3.47677L8.45165 5.34396C8.47509 5.15646 8.554 4.67911 8.729 4.00411C8.904 3.32911 9.43058 3.28433 9.68602 3.32052C10.012 3.3667 10.5657 3.68146 10.3345 4.59396C10.0595 5.75021 9.87223 7.23849 9.80713 7.87911C10.1266 7.74822 10.412 7.4504 10.7642 7.08287L10.7798 7.06661C11.1392 6.69161 11.7134 6.73458 11.9516 6.96114C12.3149 7.19552 12.5142 7.89864 12.1118 8.30099C11.6493 8.72599 9.9829 10.7059 9.15477 11.6955C8.92561 11.9872 8.1579 12.5705 6.9204 12.5705C4.71727 12.4768 3.97894 10.8944 3.87352 9.27364Z",
  fill: "url(#paint19_radial_4002_3860)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M3.87352 9.27364C3.74853 7.35177 3.59228 6.31531 3.5454 5.63302C3.51021 5.12077 3.56884 4.56662 4.25634 4.44162C4.854 4.3674 5.13915 4.89344 5.16259 5.10177C5.15998 4.90125 5.16259 4.42224 5.16259 4.29709C5.16259 4.08615 5.1704 3.32052 6.02196 3.32052C6.62331 3.32052 6.83838 3.90776 6.82275 4.1838C6.83317 4.08224 6.84541 3.77052 6.85791 3.47677C6.87634 3.04347 7.10947 2.48771 7.80322 2.50021C8.40088 2.53927 8.59619 3.11349 8.56884 3.47677L8.45165 5.34396C8.47509 5.15646 8.554 4.67911 8.729 4.00411C8.904 3.32911 9.43058 3.28433 9.68602 3.32052C10.012 3.3667 10.5657 3.68146 10.3345 4.59396C10.0595 5.75021 9.87223 7.23849 9.80713 7.87911C10.1266 7.74822 10.412 7.4504 10.7642 7.08287L10.7798 7.06661C11.1392 6.69161 11.7134 6.73458 11.9516 6.96114C12.3149 7.19552 12.5142 7.89864 12.1118 8.30099C11.6493 8.72599 9.9829 10.7059 9.15477 11.6955C8.92561 11.9872 8.1579 12.5705 6.9204 12.5705C4.71727 12.4768 3.97894 10.8944 3.87352 9.27364Z",
  fill: "url(#paint20_radial_4002_3860)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M3.87352 9.27364C3.74853 7.35177 3.59228 6.31531 3.5454 5.63302C3.51021 5.12077 3.56884 4.56662 4.25634 4.44162C4.854 4.3674 5.13915 4.89344 5.16259 5.10177C5.15998 4.90125 5.16259 4.42224 5.16259 4.29709C5.16259 4.08615 5.1704 3.32052 6.02196 3.32052C6.62331 3.32052 6.83838 3.90776 6.82275 4.1838C6.83317 4.08224 6.84541 3.77052 6.85791 3.47677C6.87634 3.04347 7.10947 2.48771 7.80322 2.50021C8.40088 2.53927 8.59619 3.11349 8.56884 3.47677L8.45165 5.34396C8.47509 5.15646 8.554 4.67911 8.729 4.00411C8.904 3.32911 9.43058 3.28433 9.68602 3.32052C10.012 3.3667 10.5657 3.68146 10.3345 4.59396C10.0595 5.75021 9.87223 7.23849 9.80713 7.87911C10.1266 7.74822 10.412 7.4504 10.7642 7.08287L10.7798 7.06661C11.1392 6.69161 11.7134 6.73458 11.9516 6.96114C12.3149 7.19552 12.5142 7.89864 12.1118 8.30099C11.6493 8.72599 9.9829 10.7059 9.15477 11.6955C8.92561 11.9872 8.1579 12.5705 6.9204 12.5705C4.71727 12.4768 3.97894 10.8944 3.87352 9.27364Z",
  fill: "url(#paint21_radial_4002_3860)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M3.87352 9.27364C3.74853 7.35177 3.59228 6.31531 3.5454 5.63302C3.51021 5.12077 3.56884 4.56662 4.25634 4.44162C4.854 4.3674 5.13915 4.89344 5.16259 5.10177C5.15998 4.90125 5.16259 4.42224 5.16259 4.29709C5.16259 4.08615 5.1704 3.32052 6.02196 3.32052C6.62331 3.32052 6.83838 3.90776 6.82275 4.1838C6.83317 4.08224 6.84541 3.77052 6.85791 3.47677C6.87634 3.04347 7.10947 2.48771 7.80322 2.50021C8.40088 2.53927 8.59619 3.11349 8.56884 3.47677L8.45165 5.34396C8.47509 5.15646 8.554 4.67911 8.729 4.00411C8.904 3.32911 9.43058 3.28433 9.68602 3.32052C10.012 3.3667 10.5657 3.68146 10.3345 4.59396C10.0595 5.75021 9.87223 7.23849 9.80713 7.87911C10.1266 7.74822 10.412 7.4504 10.7642 7.08287L10.7798 7.06661C11.1392 6.69161 11.7134 6.73458 11.9516 6.96114C12.3149 7.19552 12.5142 7.89864 12.1118 8.30099C11.6493 8.72599 9.9829 10.7059 9.15477 11.6955C8.92561 11.9872 8.1579 12.5705 6.9204 12.5705C4.71727 12.4768 3.97894 10.8944 3.87352 9.27364Z",
  fill: "url(#paint22_radial_4002_3860)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M4.9436 12.2029C4.9436 12.0925 5.03315 12.0029 5.1436 12.0029H8.95454C9.065 12.0029 9.15454 12.0925 9.15454 12.2029V13.917H4.9436V12.2029Z",
  fill: "url(#paint23_linear_4002_3860)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M4.9436 12.2029C4.9436 12.0925 5.03315 12.0029 5.1436 12.0029H8.95454C9.065 12.0029 9.15454 12.0925 9.15454 12.2029V13.917H4.9436V12.2029Z",
  fill: "url(#paint24_radial_4002_3860)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M4.9436 12.2029C4.9436 12.0925 5.03315 12.0029 5.1436 12.0029H8.95454C9.065 12.0029 9.15454 12.0925 9.15454 12.2029V13.917H4.9436V12.2029Z",
  fill: "url(#paint25_linear_4002_3860)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5584 21.0264H21.528C24.0186 21.0264 29 24.5264 29 30.0264H11.0671V26.5264C11.0671 26.2497 10.8977 25.9935 10.653 25.9013L7.5802 24.5264C5.08953 23.5264 4.09326 21.0264 4.09326 19.3284V14.0408C4.09326 13.4773 4.51685 13.0264 5.02515 13.0264L9.13899 13.0264C9.65671 13.0264 10.0709 13.4875 10.0709 14.0408V18.0264C10.0709 19.3284 11.0671 19.5264 11.0671 19.5264L17.0448 21.0264H20.5584Z",
  fill: "url(#paint26_linear_4002_3860)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5584 21.0264H21.528C24.0186 21.0264 29 24.5264 29 30.0264H11.0671V26.5264C11.0671 26.2497 10.8977 25.9935 10.653 25.9013L7.5802 24.5264C5.08953 23.5264 4.09326 21.0264 4.09326 19.3284V14.0408C4.09326 13.4773 4.51685 13.0264 5.02515 13.0264L9.13899 13.0264C9.65671 13.0264 10.0709 13.4875 10.0709 14.0408V18.0264C10.0709 19.3284 11.0671 19.5264 11.0671 19.5264L17.0448 21.0264H20.5584Z",
  fill: "url(#paint27_radial_4002_3860)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5584 21.0264H21.528C24.0186 21.0264 29 24.5264 29 30.0264H11.0671V26.5264C11.0671 26.2497 10.8977 25.9935 10.653 25.9013L7.5802 24.5264C5.08953 23.5264 4.09326 21.0264 4.09326 19.3284V14.0408C4.09326 13.4773 4.51685 13.0264 5.02515 13.0264L9.13899 13.0264C9.65671 13.0264 10.0709 13.4875 10.0709 14.0408V18.0264C10.0709 19.3284 11.0671 19.5264 11.0671 19.5264L17.0448 21.0264H20.5584Z",
  fill: "url(#paint28_radial_4002_3860)"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9513 21.1357L11.0776 26.3811C11.0302 26.1635 10.8794 25.9771 10.6775 25.9013L7.59326 24.5264C5.09326 23.5264 4.09326 21.0264 4.09326 19.3284V14.0408C4.09326 13.4773 4.51843 13.0264 5.02864 13.0264L9.15789 13.0264C9.67754 13.0264 10.0933 13.4875 10.0933 14.0408V18.0264C10.0933 19.3284 11.0933 19.5264 11.0933 19.5264L17.0933 21.0264L18.9513 21.1357Z",
  fill: "url(#paint29_linear_4002_3860)"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9513 21.1357L11.0776 26.3811C11.0302 26.1635 10.8794 25.9771 10.6775 25.9013L7.59326 24.5264C5.09326 23.5264 4.09326 21.0264 4.09326 19.3284V14.0408C4.09326 13.4773 4.51843 13.0264 5.02864 13.0264L9.15789 13.0264C9.67754 13.0264 10.0933 13.4875 10.0933 14.0408V18.0264C10.0933 19.3284 11.0933 19.5264 11.0933 19.5264L17.0933 21.0264L18.9513 21.1357Z",
  fill: "url(#paint30_radial_4002_3860)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9513 21.1357L11.0776 26.3811C11.0302 26.1635 10.8794 25.9771 10.6775 25.9013L7.59326 24.5264C5.09326 23.5264 4.09326 21.0264 4.09326 19.3284V14.0408C4.09326 13.4773 4.51843 13.0264 5.02864 13.0264L9.15789 13.0264C9.67754 13.0264 10.0933 13.4875 10.0933 14.0408V18.0264C10.0933 19.3284 11.0933 19.5264 11.0933 19.5264L17.0933 21.0264L18.9513 21.1357Z",
  fill: "url(#paint31_radial_4002_3860)"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9513 21.1357L11.0776 26.3811C11.0302 26.1635 10.8794 25.9771 10.6775 25.9013L7.59326 24.5264C5.09326 23.5264 4.09326 21.0264 4.09326 19.3284V14.0408C4.09326 13.4773 4.51843 13.0264 5.02864 13.0264L9.15789 13.0264C9.67754 13.0264 10.0933 13.4875 10.0933 14.0408V18.0264C10.0933 19.3284 11.0933 19.5264 11.0933 19.5264L17.0933 21.0264L18.9513 21.1357Z",
  fill: "url(#paint32_radial_4002_3860)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9513 21.1357L11.0776 26.3811C11.0302 26.1635 10.8794 25.9771 10.6775 25.9013L7.59326 24.5264C5.09326 23.5264 4.09326 21.0264 4.09326 19.3284V14.0408C4.09326 13.4773 4.51843 13.0264 5.02864 13.0264L9.15789 13.0264C9.67754 13.0264 10.0933 13.4875 10.0933 14.0408V18.0264C10.0933 19.3284 11.0933 19.5264 11.0933 19.5264L17.0933 21.0264L18.9513 21.1357Z",
  fill: "url(#paint33_linear_4002_3860)"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M18.9513 21.1357L11.0776 26.3811C11.0302 26.1635 10.8794 25.9771 10.6775 25.9013L7.59326 24.5264C5.09326 23.5264 4.09326 21.0264 4.09326 19.3284V14.0408C4.09326 13.4773 4.51843 13.0264 5.02864 13.0264L9.15789 13.0264C9.67754 13.0264 10.0933 13.4875 10.0933 14.0408V18.0264C10.0933 19.3284 11.0933 19.5264 11.0933 19.5264L17.0933 21.0264L18.9513 21.1357Z",
  fill: "url(#paint34_linear_4002_3860)"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5933 24.1321C18.3255 24.1321 17.2971 23.1466 17.2971 21.9318V19.3323C17.2971 18.1175 18.3255 17.1321 19.5933 17.1321C20.8611 17.1321 21.8895 18.1175 21.8895 19.3323V21.9318C21.8895 23.1466 20.8611 24.1321 19.5933 24.1321Z",
  fill: "url(#paint35_linear_4002_3860)"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M19.5933 24.1321C18.3255 24.1321 17.2971 23.1466 17.2971 21.9318V19.3323C17.2971 18.1175 18.3255 17.1321 19.5933 17.1321C20.8611 17.1321 21.8895 18.1175 21.8895 19.3323V21.9318C21.8895 23.1466 20.8611 24.1321 19.5933 24.1321Z",
  fill: "url(#paint36_radial_4002_3860)"
});

var _ref28 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_f_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.93579 13.9541L7.9356 19.1256C7.93557 19.9915 8.49272 20.7591 9.31598 21.0273L13.498 22.39",
  stroke: "url(#paint37_linear_4002_3860)"
}));

var _ref29 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_f_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.18677 5.21326L5.31866 6.63223",
  stroke: "url(#paint38_linear_4002_3860)",
  strokeWidth: 0.075,
  strokeLinecap: "round"
}));

var _ref30 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_f_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.81958 4.29919L6.72583 6.36169",
  stroke: "url(#paint39_linear_4002_3860)",
  strokeWidth: 0.075,
  strokeLinecap: "round"
}));

var _ref31 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_f_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.42896 5.43201L8.27271 6.63513",
  stroke: "url(#paint40_linear_4002_3860)",
  strokeWidth: 0.075,
  strokeLinecap: "round"
}));

var _ref32 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter5_i_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.8816 16.4402C14.9649 16.4402 15.8431 15.562 15.8431 14.4787C15.8431 13.3954 14.9649 12.5172 13.8816 12.5172C12.7983 12.5172 11.9202 13.3954 11.9202 14.4787C11.9202 15.562 12.7983 16.4402 13.8816 16.4402Z",
  fill: "url(#paint41_linear_4002_3860)"
}));

var _ref33 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter6_i_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.4778 16.4402C26.5611 16.4402 27.4393 15.562 27.4393 14.4787C27.4393 13.3954 26.5611 12.5172 25.4778 12.5172C24.3945 12.5172 23.5164 13.3954 23.5164 14.4787C23.5164 15.562 24.3945 16.4402 25.4778 16.4402Z",
  fill: "url(#paint42_radial_4002_3860)"
}));

var _ref34 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter7_f_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.4778 15.7881C26.2009 15.7881 26.7871 15.2018 26.7871 14.4787C26.7871 13.7556 26.2009 13.1694 25.4778 13.1694C24.7547 13.1694 24.1685 13.7556 24.1685 14.4787C24.1685 15.2018 24.7547 15.7881 25.4778 15.7881Z",
  fill: "#FFCA38"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.4778 15.7881C26.2009 15.7881 26.7871 15.2018 26.7871 14.4787C26.7871 13.7556 26.2009 13.1694 25.4778 13.1694C24.7547 13.1694 24.1685 13.7556 24.1685 14.4787C24.1685 15.2018 24.7547 15.7881 25.4778 15.7881Z",
  fill: "url(#paint43_radial_4002_3860)"
}));

var _ref35 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter8_f_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.905 15.7881C14.6282 15.7881 15.2144 15.2018 15.2144 14.4787C15.2144 13.7556 14.6282 13.1694 13.905 13.1694C13.1819 13.1694 12.5957 13.7556 12.5957 14.4787C12.5957 15.2018 13.1819 15.7881 13.905 15.7881Z",
  fill: "#E28527"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.905 15.7881C14.6282 15.7881 15.2144 15.2018 15.2144 14.4787C15.2144 13.7556 14.6282 13.1694 13.905 13.1694C13.1819 13.1694 12.5957 13.7556 12.5957 14.4787C12.5957 15.2018 13.1819 15.7881 13.905 15.7881Z",
  fill: "url(#paint44_radial_4002_3860)"
}));

var _ref36 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter9_i_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.3921 12.9395H13.4071L13.3946 12.6161L13.3821 12.243C13.4071 11.0863 14.0821 10.6386 14.3696 10.4893C14.3884 10.4831 14.4103 10.4738 14.4321 10.4644C14.454 10.4551 14.4759 10.4458 14.4946 10.4396C15.1447 10.1411 15.6697 9.61869 15.9447 8.93463L16.0447 8.69832C16.1447 8.46201 16.4572 8.42469 16.6072 8.63613C17.4823 9.91719 18.9449 10.6759 20.4949 10.6759H24.4201C24.6396 10.6759 25.7393 10.7824 25.8048 12.2998L25.66 16.0459C25.5097 19.4621 22.8419 21.7561 19.5854 21.7561C16.329 21.7561 13.6612 19.4621 13.5109 16.0459L13.3921 12.9395Z",
  fill: "url(#paint45_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.3921 12.9395H13.4071L13.3946 12.6161L13.3821 12.243C13.4071 11.0863 14.0821 10.6386 14.3696 10.4893C14.3884 10.4831 14.4103 10.4738 14.4321 10.4644C14.454 10.4551 14.4759 10.4458 14.4946 10.4396C15.1447 10.1411 15.6697 9.61869 15.9447 8.93463L16.0447 8.69832C16.1447 8.46201 16.4572 8.42469 16.6072 8.63613C17.4823 9.91719 18.9449 10.6759 20.4949 10.6759H24.4201C24.6396 10.6759 25.7393 10.7824 25.8048 12.2998L25.66 16.0459C25.5097 19.4621 22.8419 21.7561 19.5854 21.7561C16.329 21.7561 13.6612 19.4621 13.5109 16.0459L13.3921 12.9395Z",
  fill: "url(#paint46_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.3921 12.9395H13.4071L13.3946 12.6161L13.3821 12.243C13.4071 11.0863 14.0821 10.6386 14.3696 10.4893C14.3884 10.4831 14.4103 10.4738 14.4321 10.4644C14.454 10.4551 14.4759 10.4458 14.4946 10.4396C15.1447 10.1411 15.6697 9.61869 15.9447 8.93463L16.0447 8.69832C16.1447 8.46201 16.4572 8.42469 16.6072 8.63613C17.4823 9.91719 18.9449 10.6759 20.4949 10.6759H24.4201C24.6396 10.6759 25.7393 10.7824 25.8048 12.2998L25.66 16.0459C25.5097 19.4621 22.8419 21.7561 19.5854 21.7561C16.329 21.7561 13.6612 19.4621 13.5109 16.0459L13.3921 12.9395Z",
  fill: "url(#paint47_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.3921 12.9395H13.4071L13.3946 12.6161L13.3821 12.243C13.4071 11.0863 14.0821 10.6386 14.3696 10.4893C14.3884 10.4831 14.4103 10.4738 14.4321 10.4644C14.454 10.4551 14.4759 10.4458 14.4946 10.4396C15.1447 10.1411 15.6697 9.61869 15.9447 8.93463L16.0447 8.69832C16.1447 8.46201 16.4572 8.42469 16.6072 8.63613C17.4823 9.91719 18.9449 10.6759 20.4949 10.6759H24.4201C24.6396 10.6759 25.7393 10.7824 25.8048 12.2998L25.66 16.0459C25.5097 19.4621 22.8419 21.7561 19.5854 21.7561C16.329 21.7561 13.6612 19.4621 13.5109 16.0459L13.3921 12.9395Z",
  fill: "url(#paint48_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.3921 12.9395H13.4071L13.3946 12.6161L13.3821 12.243C13.4071 11.0863 14.0821 10.6386 14.3696 10.4893C14.3884 10.4831 14.4103 10.4738 14.4321 10.4644C14.454 10.4551 14.4759 10.4458 14.4946 10.4396C15.1447 10.1411 15.6697 9.61869 15.9447 8.93463L16.0447 8.69832C16.1447 8.46201 16.4572 8.42469 16.6072 8.63613C17.4823 9.91719 18.9449 10.6759 20.4949 10.6759H24.4201C24.6396 10.6759 25.7393 10.7824 25.8048 12.2998L25.66 16.0459C25.5097 19.4621 22.8419 21.7561 19.5854 21.7561C16.329 21.7561 13.6612 19.4621 13.5109 16.0459L13.3921 12.9395Z",
  fill: "url(#paint49_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.3921 12.9395H13.4071L13.3946 12.6161L13.3821 12.243C13.4071 11.0863 14.0821 10.6386 14.3696 10.4893C14.3884 10.4831 14.4103 10.4738 14.4321 10.4644C14.454 10.4551 14.4759 10.4458 14.4946 10.4396C15.1447 10.1411 15.6697 9.61869 15.9447 8.93463L16.0447 8.69832C16.1447 8.46201 16.4572 8.42469 16.6072 8.63613C17.4823 9.91719 18.9449 10.6759 20.4949 10.6759H24.4201C24.6396 10.6759 25.7393 10.7824 25.8048 12.2998L25.66 16.0459C25.5097 19.4621 22.8419 21.7561 19.5854 21.7561C16.329 21.7561 13.6612 19.4621 13.5109 16.0459L13.3921 12.9395Z",
  fill: "url(#paint50_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.3921 12.9395H13.4071L13.3946 12.6161L13.3821 12.243C13.4071 11.0863 14.0821 10.6386 14.3696 10.4893C14.3884 10.4831 14.4103 10.4738 14.4321 10.4644C14.454 10.4551 14.4759 10.4458 14.4946 10.4396C15.1447 10.1411 15.6697 9.61869 15.9447 8.93463L16.0447 8.69832C16.1447 8.46201 16.4572 8.42469 16.6072 8.63613C17.4823 9.91719 18.9449 10.6759 20.4949 10.6759H24.4201C24.6396 10.6759 25.7393 10.7824 25.8048 12.2998L25.66 16.0459C25.5097 19.4621 22.8419 21.7561 19.5854 21.7561C16.329 21.7561 13.6612 19.4621 13.5109 16.0459L13.3921 12.9395Z",
  fill: "url(#paint51_radial_4002_3860)"
}));

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M13.3921 12.9395H13.4071L13.3946 12.6161L13.3821 12.243C13.4071 11.0863 14.0821 10.6386 14.3696 10.4893C14.3884 10.4831 14.4103 10.4738 14.4321 10.4644C14.454 10.4551 14.4759 10.4458 14.4946 10.4396C15.1447 10.1411 15.6697 9.61869 15.9447 8.93463L16.0447 8.69832C16.1447 8.46201 16.4572 8.42469 16.6072 8.63613C17.4823 9.91719 18.9449 10.6759 20.4949 10.6759H24.4201C24.6396 10.6759 25.7393 10.7824 25.8048 12.2998L25.66 16.0459C25.5097 19.4621 22.8419 21.7561 19.5854 21.7561C16.329 21.7561 13.6612 19.4621 13.5109 16.0459L13.3921 12.9395Z",
  fill: "url(#paint52_radial_4002_3860)"
});

var _ref38 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter10_f_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.1148 14.2072L18.2815 16.2795C18.1493 16.7058 18.4666 17.132 18.9161 17.132H19.8747C20.3242 17.132 20.6416 16.6992 20.5093 16.2795L19.8615 14.2072C19.7227 13.7482 19.2602 13.7482 19.1148 14.2072Z",
  fill: "#EB8B29"
}));

var _ref39 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter11_f_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.1273 14.0384L18.4795 16.1108C18.3473 16.537 18.6646 16.9633 19.1141 16.9633H20.0727C20.5222 16.9633 20.8396 16.5305 20.7073 16.1108L20.0595 14.0384C19.9207 13.5794 19.2728 13.5794 19.1273 14.0384Z",
  fill: "url(#paint53_linear_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.1273 14.0384L18.4795 16.1108C18.3473 16.537 18.6646 16.9633 19.1141 16.9633H20.0727C20.5222 16.9633 20.8396 16.5305 20.7073 16.1108L20.0595 14.0384C19.9207 13.5794 19.2728 13.5794 19.1273 14.0384Z",
  fill: "url(#paint54_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.1273 14.0384L18.4795 16.1108C18.3473 16.537 18.6646 16.9633 19.1141 16.9633H20.0727C20.5222 16.9633 20.8396 16.5305 20.7073 16.1108L20.0595 14.0384C19.9207 13.5794 19.2728 13.5794 19.1273 14.0384Z",
  fill: "url(#paint55_linear_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.1273 14.0384L18.4795 16.1108C18.3473 16.537 18.6646 16.9633 19.1141 16.9633H20.0727C20.5222 16.9633 20.8396 16.5305 20.7073 16.1108L20.0595 14.0384C19.9207 13.5794 19.2728 13.5794 19.1273 14.0384Z",
  fill: "url(#paint56_linear_4002_3860)"
}));

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1273 14.0384L18.4795 16.1108C18.3473 16.537 18.6646 16.9633 19.1141 16.9633H20.0727C20.5222 16.9633 20.8396 16.5305 20.7073 16.1108L20.0595 14.0384C19.9207 13.5794 19.2728 13.5794 19.1273 14.0384Z",
  fill: "url(#paint57_linear_4002_3860)"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M19.1273 14.0384L18.4795 16.1108C18.3473 16.537 18.6646 16.9633 19.1141 16.9633H20.0727C20.5222 16.9633 20.8396 16.5305 20.7073 16.1108L20.0595 14.0384C19.9207 13.5794 19.2728 13.5794 19.1273 14.0384Z",
  fill: "url(#paint58_radial_4002_3860)"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8841 17.5636L17.8841 17.5636C18.3781 17.827 18.9667 17.9779 19.5935 17.9779C20.2266 17.9779 20.8089 17.827 21.3029 17.5636L21.3033 17.5634L21.3033 17.5634C21.4111 17.5073 21.5238 17.5399 21.5913 17.6116C21.6593 17.6838 21.6838 17.7981 21.6159 17.9023M17.8841 17.5636L21.574 17.8751M17.8841 17.5636L17.8836 17.5634C17.7752 17.507 17.6624 17.5421 17.5954 17.6143C17.5283 17.6865 17.5026 17.801 17.5713 17.9027M17.8841 17.5636L17.613 17.8751M21.6159 17.9023C21.6159 17.9023 21.6159 17.9024 21.6159 17.9024L21.574 17.8751M21.6159 17.9023C21.616 17.9023 21.616 17.9022 21.616 17.9022L21.574 17.8751M21.6159 17.9023C21.1882 18.5652 20.4428 19.0074 19.5935 19.0074C18.7443 19.0074 17.999 18.5654 17.5713 17.9027M21.574 17.8751C21.155 18.5245 20.425 18.9574 19.5935 18.9574C18.7619 18.9574 18.0319 18.5245 17.613 17.8751M17.5713 17.9027C17.5714 17.9028 17.5715 17.903 17.5716 17.9032L17.613 17.8751M17.5713 17.9027C17.5712 17.9025 17.5711 17.9024 17.571 17.9022L17.613 17.8751",
  fill: "#8A004F",
  stroke: "url(#paint59_linear_4002_3860)",
  strokeWidth: 0.1
});

var _ref43 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter12_i_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.9857 13.785C21.3093 13.216 21.8011 12.7665 22.8598 12.7665C23.3233 12.7665 23.7702 12.895 24.1675 13.216C24.4952 13.4808 24.4513 13.8196 24.1976 13.9465L23.5198 14.3335C22.7252 14.0766 21.8465 14.0419 20.9857 13.785Z",
  fill: "#635D5F"
}));

var _ref44 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter13_i_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.2015 13.785C17.878 13.216 17.3861 12.7665 16.3275 12.7665C15.864 12.7665 15.417 12.895 15.0197 13.216C14.692 13.4808 14.7359 13.8196 14.9897 13.9465L15.6675 14.3335C16.4621 14.0766 17.3407 14.0419 18.2015 13.785Z",
  fill: "#635D5F"
}));

var _ref45 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter14_i_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.4516 12.3115L15.4463 12.3145C15.4461 12.3146 15.446 12.3147 15.4458 12.3148C15.2911 12.4072 15.0905 12.357 14.9978 12.2024C14.9049 12.0476 14.9553 11.8467 15.1101 11.7538L15.1108 11.7534L15.112 11.7526L15.1156 11.7505L15.1271 11.7438C15.1366 11.7384 15.1499 11.731 15.1667 11.7219C15.2002 11.7037 15.2479 11.6789 15.308 11.6502C15.4281 11.593 15.5994 11.5197 15.808 11.4531C16.2223 11.3208 16.8017 11.2096 17.4271 11.32C17.6049 11.3514 17.7236 11.5209 17.6923 11.6987C17.6609 11.8765 17.4913 11.9952 17.3135 11.9639C16.8275 11.8781 16.3607 11.963 16.0068 12.0759C15.8313 12.1319 15.6879 12.1935 15.5893 12.2404C15.5402 12.2639 15.5026 12.2835 15.4781 12.2967C15.4659 12.3034 15.457 12.3084 15.4516 12.3115Z",
  fill: "#BD4F26"
}));

var _ref46 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter15_i_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.1422 11.7538C24.1422 11.7538 24.1423 11.7539 23.9741 12.0342L24.1422 11.7538C24.297 11.8467 24.3474 12.0476 24.2545 12.2024C24.1617 12.357 23.9613 12.4073 23.8066 12.3149C23.8065 12.3149 23.8063 12.3147 23.806 12.3146L23.8006 12.3115C23.7952 12.3084 23.7863 12.3034 23.7741 12.2967C23.7496 12.2835 23.712 12.2639 23.6629 12.2404C23.5644 12.1935 23.4209 12.1319 23.2454 12.0759C22.8915 11.963 22.4248 11.8781 21.9387 11.9639C21.7609 11.9952 21.5913 11.8765 21.56 11.6987C21.5286 11.5209 21.6473 11.3514 21.8251 11.32C22.4505 11.2096 23.0299 11.3208 23.4442 11.4531C23.6529 11.5197 23.8241 11.593 23.9442 11.6502C24.0044 11.6789 24.0521 11.7037 24.0856 11.7219C24.1023 11.731 24.1156 11.7384 24.1251 11.7438L24.1366 11.7505L24.1402 11.7526L24.1414 11.7534L24.1422 11.7538Z",
  fill: "#BD4F26"
}));

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M22.508 12.8381C23.3042 12.8381 23.9767 13.387 24.1597 14.1287C24.2141 14.3413 24.0509 14.5441 23.8333 14.5441H21.1136C20.9405 14.5441 20.802 14.3859 20.8366 14.2128C20.9899 13.4315 21.6773 12.8381 22.508 12.8381Z",
  fill: "white"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M22.2559 13.1694C22.8592 13.1694 23.3438 13.6589 23.3438 14.2573C23.3438 14.3562 23.329 14.4551 23.3043 14.5441H21.2026C21.1779 14.4501 21.1631 14.3562 21.1631 14.2573C21.1631 13.6589 21.6526 13.1694 22.2559 13.1694Z",
  fill: "url(#paint60_radial_4002_3860)"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6328 14.2573C21.6328 13.9111 21.9097 13.6342 22.2559 13.6342C22.602 13.6342 22.8789 13.9111 22.8789 14.2573C22.8789 14.3611 22.8542 14.46 22.8097 14.5441H21.707C21.6575 14.46 21.6328 14.3611 21.6328 14.2573Z",
  fill: "black"
});

var _ref50 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter16_f_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.1752 13.3996C22.2526 13.5032 22.0907 13.6295 21.9067 13.7671C21.7226 13.9047 21.5861 14.0016 21.5086 13.898C21.4312 13.7944 21.5176 13.5989 21.7017 13.4613C21.8857 13.3237 22.0977 13.2961 22.1752 13.3996Z",
  fill: "#C7A7A3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.1752 13.3996C22.2526 13.5032 22.0907 13.6295 21.9067 13.7671C21.7226 13.9047 21.5861 14.0016 21.5086 13.898C21.4312 13.7944 21.5176 13.5989 21.7017 13.4613C21.8857 13.3237 22.0977 13.2961 22.1752 13.3996Z",
  fill: "url(#paint61_radial_4002_3860)"
}));

var _ref51 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter17_f_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.2243 14.1136C23.1842 13.8326 23.0197 13.6208 22.9425 13.55L22.626 13.8974L22.7688 14.1753L23.2243 14.1136Z",
  fill: "url(#paint62_linear_4002_3860)"
}));

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M16.6788 12.8381C15.8826 12.8381 15.2101 13.387 15.0271 14.1287C14.9727 14.3414 15.1359 14.5441 15.3535 14.5441H18.0733C18.2463 14.5441 18.3848 14.3859 18.3502 14.2128C18.1969 13.4315 17.5046 12.8381 16.6788 12.8381Z",
  fill: "white"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9309 13.1694C16.3276 13.1694 15.843 13.6589 15.843 14.2573C15.843 14.3562 15.8579 14.4551 15.8826 14.5441H17.9842C18.0089 14.4501 18.0238 14.3562 18.0238 14.2573C18.0188 13.6589 17.5342 13.1694 16.9309 13.1694Z",
  fill: "url(#paint63_radial_4002_3860)"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M17.554 14.2573C17.554 13.9111 17.2771 13.6342 16.9309 13.6342C16.5848 13.6342 16.3079 13.9111 16.3079 14.2573C16.3079 14.3611 16.3326 14.46 16.3771 14.5441H17.4798C17.5243 14.46 17.554 14.3611 17.554 14.2573Z",
  fill: "black"
});

var _ref55 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter18_f_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.9243 14.1289C17.9243 13.7777 17.6387 13.5435 17.5615 13.4727L17.2102 13.8124L17.4264 14.2525L17.9243 14.1289Z",
  fill: "url(#paint64_linear_4002_3860)"
}));

var _ref56 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter19_f_4002_3860)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 16.6023,
  cy: 13.6342,
  rx: 0.474544,
  ry: 0.240163,
  transform: "rotate(-27.914 16.6023 13.6342)",
  fill: "#C7A7A3",
  fillOpacity: 0.9
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 16.6023,
  cy: 13.6342,
  rx: 0.474544,
  ry: 0.240163,
  transform: "rotate(-27.914 16.6023 13.6342)",
  fill: "url(#paint65_radial_4002_3860)"
}));

var _ref57 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter20_f_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.9578 11.5864C22.351 11.4908 23.3287 11.5386 23.9822 12.0062",
  stroke: "#C9725D",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref58 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter21_f_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.3367 11.5864C16.9435 11.4908 15.9658 11.5386 15.3122 12.0062",
  stroke: "#C9725D",
  strokeWidth: 0.4,
  strokeLinecap: "round"
}));

var _ref59 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter22_f_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.6273 7.14773C14.3844 6.47347 15.4764 6.46666 16.0894 6.57563L16.5797 8.1489C16.2664 8.10123 15.9872 8.2102 15.7522 8.43495C15.1965 9.97145 13.2868 10.8187 12.4014 11.0503C12.2175 9.2318 12.3196 8.31236 13.6273 7.14773Z",
  fill: "url(#paint66_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.6273 7.14773C14.3844 6.47347 15.4764 6.46666 16.0894 6.57563L16.5797 8.1489C16.2664 8.10123 15.9872 8.2102 15.7522 8.43495C15.1965 9.97145 13.2868 10.8187 12.4014 11.0503C12.2175 9.2318 12.3196 8.31236 13.6273 7.14773Z",
  fill: "url(#paint67_radial_4002_3860)"
}));

var _ref60 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter23_f_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.858 4.98189C17.4773 4.67705 15.9975 6.14652 15.8545 6.65732C17.7342 11.0706 20.6206 10.65 23.823 10.2942C25.74 10.0812 25.9479 10.9549 26.1114 11.3771C25.5802 6.43256 22.0045 5.67658 18.858 4.98189Z",
  fill: "url(#paint68_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.858 4.98189C17.4773 4.67705 15.9975 6.14652 15.8545 6.65732C17.7342 11.0706 20.6206 10.65 23.823 10.2942C25.74 10.0812 25.9479 10.9549 26.1114 11.3771C25.5802 6.43256 22.0045 5.67658 18.858 4.98189Z",
  fill: "url(#paint69_radial_4002_3860)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.858 4.98189C17.4773 4.67705 15.9975 6.14652 15.8545 6.65732C17.7342 11.0706 20.6206 10.65 23.823 10.2942C25.74 10.0812 25.9479 10.9549 26.1114 11.3771C25.5802 6.43256 22.0045 5.67658 18.858 4.98189Z",
  fill: "url(#paint70_radial_4002_3860)"
}));

var _ref61 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter24_f_4002_3860)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.0688 6.50409C16.0972 6.80035 16.3549 7.9139 16.7329 8.58816",
  stroke: "url(#paint71_linear_4002_3860)",
  strokeWidth: 0.1,
  strokeLinecap: "round"
}));

var _ref62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_i_4002_3860",
  x: 10.4399,
  y: 3.83289,
  width: 18.5571,
  height: 18.5571,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.25,
  dy: -0.25
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.375
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.92549 0 0 0 0 0.537255 0 0 0 0 0.12549 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f_4002_3860",
  x: 5.93555,
  y: 12.4541,
  width: 9.21741,
  height: 11.9113,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.75,
  result: "effect1_foregroundBlur_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f_4002_3860",
  x: 5.04929,
  y: 5.07578,
  width: 0.406909,
  height: 1.69396,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.05,
  result: "effect1_foregroundBlur_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_f_4002_3860",
  x: 6.58835,
  y: 4.16172,
  width: 0.368701,
  height: 2.33745,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.05,
  result: "effect1_foregroundBlur_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_f_4002_3860",
  x: 8.13523,
  y: 5.29453,
  width: 0.431201,
  height: 1.47808,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.05,
  result: "effect1_foregroundBlur_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter5_i_4002_3860",
  x: 11.9202,
  y: 12.5172,
  width: 4.02297,
  height: 3.92297,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.768627 0 0 0 0 0.501961 0 0 0 0 0.160784 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter6_i_4002_3860",
  x: 23.5164,
  y: 12.2672,
  width: 3.92297,
  height: 4.17297,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: -0.25
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.937255 0 0 0 0 0.576471 0 0 0 0 0.341176 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter7_f_4002_3860",
  x: 23.6685,
  y: 12.6694,
  width: 3.61865,
  height: 3.61871,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  result: "effect1_foregroundBlur_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter8_f_4002_3860",
  x: 12.3457,
  y: 12.9194,
  width: 3.11865,
  height: 3.11871,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125,
  result: "effect1_foregroundBlur_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter9_i_4002_3860",
  x: 13.3821,
  y: 8.49725,
  width: 12.4227,
  height: 13.6589,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 0.4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.3
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.92549 0 0 0 0 0.529412 0 0 0 0 0.137255 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter10_f_4002_3860",
  x: 17.7512,
  y: 13.3629,
  width: 3.28845,
  height: 4.2691,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  result: "effect1_foregroundBlur_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter11_f_4002_3860",
  x: 18.1992,
  y: 13.4442,
  width: 2.78845,
  height: 3.7691,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125,
  result: "effect1_foregroundBlur_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter12_i_4002_3860",
  x: 20.7857,
  y: 12.7665,
  width: 3.61492,
  height: 1.56696,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: -0.2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.141176 0 0 0 0 0.0862745 0 0 0 0 0.176471 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter13_i_4002_3860",
  x: 14.7866,
  y: 12.7665,
  width: 3.61492,
  height: 1.56696,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.133333 0 0 0 0 0.0784314 0 0 0 0 0.168627 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter14_i_4002_3860",
  x: 14.9512,
  y: 11.075,
  width: 2.94609,
  height: 1.28612,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.2,
  dy: -0.2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.658824 0 0 0 0 0.270588 0 0 0 0 0.141176 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter15_i_4002_3860",
  x: 21.5549,
  y: 11.075,
  width: 2.94609,
  height: 1.28618,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0.2,
  dy: -0.2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.658824 0 0 0 0 0.270588 0 0 0 0 0.141176 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect1_innerShadow_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter16_f_4002_3860",
  x: 21.3802,
  y: 13.2369,
  width: 0.914844,
  height: 0.804553,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.05,
  result: "effect1_foregroundBlur_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter17_f_4002_3860",
  x: 22.426,
  y: 13.35,
  width: 0.998267,
  height: 1.02537,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1,
  result: "effect1_foregroundBlur_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter18_f_4002_3860",
  x: 17.0102,
  y: 13.2727,
  width: 1.11411,
  height: 1.17972,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.1,
  result: "effect1_foregroundBlur_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter19_f_4002_3860",
  x: 16.0681,
  y: 13.227,
  width: 1.06853,
  height: 0.814441,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.05,
  result: "effect1_foregroundBlur_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter20_f_4002_3860",
  x: 21.3577,
  y: 10.9458,
  width: 3.22456,
  height: 1.66047,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2,
  result: "effect1_foregroundBlur_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter21_f_4002_3860",
  x: 14.7122,
  y: 10.9458,
  width: 3.22456,
  height: 1.66047,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.2,
  result: "effect1_foregroundBlur_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter22_f_4002_3860",
  x: 11.5811,
  y: 5.77344,
  width: 5.74866,
  height: 6.02679,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.375,
  result: "effect1_foregroundBlur_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter23_f_4002_3860",
  x: 15.3545,
  y: 4.44067,
  width: 11.2568,
  height: 7.43646,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.25,
  result: "effect1_foregroundBlur_4002_3860"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter24_f_4002_3860",
  x: 15.7688,
  y: 6.2041,
  width: 1.26416,
  height: 2.68408,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.125,
  result: "effect1_foregroundBlur_4002_3860"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_4002_3860",
  x1: 25.3146,
  y1: 6.00352,
  x2: 16.4874,
  y2: 22.39,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD93C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E37923"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(24.2537 18.5) rotate(28.3008) scale(3.88807 5.50726)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.616274,
  stopColor: "#E38923"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E38923",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(14.0213 16.9576) rotate(90) scale(5.43242 3.27286)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C9641B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D77117",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.5935 17.0705) rotate(90) scale(6.79105 7.07411)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.617268,
  stopColor: "#E26B25"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E26B25",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(13.6075 14.8697) rotate(127.617) scale(2.47792 2.40593)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.161391,
  stopColor: "#C9681C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C9681C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(14.328 11.8995) rotate(100.537) scale(3.11686 3.24562)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.365444,
  stopColor: "#D76A18"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D76A18",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(15.5261 5.74712) rotate(62.6046) scale(2.9024 5.52901)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.221806,
  stopColor: "#CBA140"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.921111,
  stopColor: "#CBA140",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(26.2953 7.47463) rotate(132.51) scale(1.99566 2.7889)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDF3C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFDF3C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint8_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(28.7471 13.4408) rotate(163.779) scale(2.3406 5.09284)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD537"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD336",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFD537",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint9_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(26.4603 22.9164) rotate(-133.315) scale(5.68317 8.16169)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#CB6325"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CB6325",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint10_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.2963 8.78803) rotate(-90.3515) scale(1.67538 0.549304)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.295258,
  stopColor: "#DB6009"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DB6009",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint11_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(18.5429 22.045) rotate(-134.119) scale(10.1929 9.02205)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.280035,
  stopColor: "#803706"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D96D24",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint12_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(6.45289 11.9096) rotate(-68.8849) scale(6.4772 7.74881)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.474886,
  stopColor: "#F4B937"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F2B830"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EEB32A"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint13_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.7171 10.0236) rotate(130.764) scale(9.5721 2.30417)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.146595,
  stopColor: "#D27C28"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E9AA33",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_4002_3860",
  x1: 6.93581,
  y1: 12.5705,
  x2: 6.93581,
  y2: 10.8674,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C77505"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EFB234",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint15_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(5.17799 5.09667) rotate(85.0559) scale(2.26624 0.271747)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.415337,
  stopColor: "#E5A70F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAAA15",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint16_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(6.82643 3.93261) rotate(90.7884) scale(3.40657 0.26603)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.400744,
  stopColor: "#EAAA15"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAAA15",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint17_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(8.79518 3.16698) rotate(99.6086) scale(4.02522 0.57523)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.651533,
  stopColor: "#EAAA15"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EAAA15",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint18_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(10.1389 3.71386) rotate(136.548) scale(1.22684 1.23301)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDC45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFDC45",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint19_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(8.38893 2.80761) rotate(138.965) scale(1.11858 0.93215)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDC45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFDC45",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint20_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(6.26393 3.37011) rotate(123.111) scale(0.858096 0.778796)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDC45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFDC45",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint21_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(4.68581 4.65136) rotate(129.369) scale(0.78825 0.715405)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDC45"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFDC45",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint22_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(4.70143 5.2373) rotate(85.7226) scale(2.30438 0.446986)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFCC3D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFCC3D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear_4002_3860",
  x1: 4.77954,
  y1: 12.5889,
  x2: 9.15454,
  y2: 12.5889,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#77639C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.742857,
  stopColor: "#5F3B73"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint24_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(7.71014 12.4789) rotate(90) scale(1.10937 1.15625)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6E5098"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6E5098",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear_4002_3860",
  x1: 7.04907,
  y1: 12.0029,
  x2: 7.04907,
  y2: 12.2607,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#674A85"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#674A85",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint26_linear_4002_3860",
  x1: 13.9779,
  y1: 24.5127,
  x2: 6.04024,
  y2: 13.0264,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8F63E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#855FCF"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint27_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(26.6806 27.2279) rotate(162.136) scale(9.12271 9.7572)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A47FF0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A47FF0",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint28_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(11.4705 30.0264) rotate(-90) scale(4.62502 2.65624)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9473D7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9473D7",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint29_linear_4002_3860",
  x1: 10.0458,
  y1: 26.6943,
  x2: 12.0024,
  y2: 20.4098,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.100065,
  stopColor: "#8751E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8751E0",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint30_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(3.56065 13.0264) rotate(90) scale(8.8125 5.4375)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8F75C7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8F75C7",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint31_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(18.2837 20.4316) rotate(-167.876) scale(10.3399 4.20474)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.286567,
  stopColor: "#522A56"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7952B0",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint32_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(12.3305 15.9386) rotate(-180) scale(5.69115 5.7286)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.131579,
  stopColor: "#522A56"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7952B0",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint33_linear_4002_3860",
  x1: 14.3149,
  y1: 24.7187,
  x2: 13.5763,
  y2: 23.3232,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.213266,
  stopColor: "#8F63E1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.732311,
  stopColor: "#8F63E1",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint34_linear_4002_3860",
  x1: 7.57536,
  y1: 13.0264,
  x2: 7.57536,
  y2: 14.0665,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7354A3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7354A3",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint35_linear_4002_3860",
  x1: 17.9044,
  y1: 20.7571,
  x2: 19.9044,
  y2: 24.1321,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#D16C15"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC436"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint36_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.5933 21.3196) rotate(90) scale(1.15625 2.61254)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E97E36"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E97E36",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint37_linear_4002_3860",
  x1: 7.59204,
  y1: 14.7338,
  x2: 13.342,
  y2: 23.015,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D74E7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9D74E7",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint38_linear_4002_3860",
  x1: 5.18677,
  y1: 5.21326,
  x2: 5.33911,
  y2: 6.72888,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BB7401"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EDAD18"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint39_linear_4002_3860",
  x1: 6.77271,
  y1: 4.42419,
  x2: 7.25573,
  y2: 6.53626,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BB7401"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EDAD18"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint40_linear_4002_3860",
  x1: 8.35083,
  y1: 5.50492,
  x2: 8.45394,
  y2: 6.79315,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BB7401"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EDAD18"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint41_linear_4002_3860",
  x1: 11.9202,
  y1: 14.585,
  x2: 15.5276,
  y2: 14.585,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E79B27"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B96201"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint42_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(24.5176 15.014) rotate(-24.444) scale(3.3329 4.06932)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.572298,
  stopColor: "#FFC531"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.904617,
  stopColor: "#FFE549"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint43_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(25.1919 14.7689) rotate(-20.2976) scale(1.59029)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.71002,
  stopColor: "#FFBA25",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFBA25"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint44_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(13.905 14.4787) rotate(180) scale(1.30934 1.25247)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.415002,
  stopColor: "#D67923",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D67923"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint45_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(23.0789 13.8235) rotate(155.244) scale(8.73018 11.6852)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE644"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EB9235"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint46_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.9099 14.6736) rotate(152.124) scale(2.90937 2.46839)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE842"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE842",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint47_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.9363 22.0914) rotate(-78.3106) scale(5.03546 6.38906)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4883F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E4883F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint48_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.2743 13.2339) rotate(90) scale(9.07009 14.4058)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.592664,
  stopColor: "#F3943B",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D97C39"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint49_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.3583 15.8426) rotate(164.542) scale(6.85819 11.8077)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.876514,
  stopColor: "#D4993E",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D4993E"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint50_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(22.3987 13.3134) rotate(-90) scale(1.40279 1.72161)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFBB31"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFBB31",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint51_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(17.2552 13.4196) rotate(-90) scale(1.65784 1.9)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F09429"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F09429",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint52_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(25.8048 15.1267) rotate(-180) scale(1.64194 5.40531)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFDA39"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFDA39",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint53_linear_4002_3860",
  x1: 19.5934,
  y1: 16.9633,
  x2: 19.5934,
  y2: 13.6942,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFC134"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F8C73F"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint54_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.5496 16.0127) rotate(-105.892) scale(3.10491 1.77667)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0168227,
  stopColor: "#FFE848"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE848",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint55_linear_4002_3860",
  x1: 18.3179,
  y1: 16.034,
  x2: 19.3593,
  y2: 16.1615,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8A322"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F8A322",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint56_linear_4002_3860",
  x1: 19.5934,
  y1: 17.0754,
  x2: 19.5934,
  y2: 16.3315,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E48538"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E48538",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint57_linear_4002_3860",
  x1: 19.6888,
  y1: 17.0436,
  x2: 19.6888,
  y2: 16.8735,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E2802F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E2802F",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint58_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(19.9438 15.577) rotate(144.462) scale(1.91979 2.57142)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.797297,
  stopColor: "#E2802F",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E2802F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint59_linear_4002_3860",
  x1: 18.7048,
  y1: 18.8757,
  x2: 19.2565,
  y2: 17.8133,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEAC35"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FEAC35",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint60_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(22.2535 13.7509) rotate(90) scale(0.988996 1.57311)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.80198,
  stopColor: "#925C51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#694B43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#804D49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#85534D"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint61_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.9747 13.8533) rotate(-127.812) scale(0.460759 0.634355)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.765532,
  stopColor: "#FFE6E2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.966159,
  stopColor: "#FFE6E2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint62_linear_4002_3860",
  x1: 23.2011,
  y1: 13.8163,
  x2: 22.819,
  y2: 14.0518,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B4948D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B4948D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint63_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.9334 13.7509) rotate(90) scale(0.989002 1.57312)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.80198,
  stopColor: "#925C51"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#694B43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#804D49"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#85534D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint64_linear_4002_3860",
  x1: 17.8397,
  y1: 13.8163,
  x2: 17.4575,
  y2: 14.0517,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B4948D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B4948D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint65_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.5839 14.0178) rotate(-90.897) scale(0.601847 0.723445)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.765532,
  stopColor: "#FFE6E2",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.966159,
  stopColor: "#FFE6E2"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint66_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.2835 6.00354) rotate(129.554) scale(6.54544 2.85467)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.395696,
  stopColor: "#EE971B",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.911046,
  stopColor: "#D8772C"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint67_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(16.1134 6.67072) rotate(144.458) scale(4.64831 2.29726)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.120488,
  stopColor: "#FFCA2D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE134",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFCA2D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint68_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(21.7772 4.57414) rotate(115.63) scale(6.15857 8.74414)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.627022,
  stopColor: "#F49523",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F49523"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint69_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(22.6517 6.10191) rotate(105.909) scale(4.19341 8.78806)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.131886,
  stopColor: "#FFE337"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFE337",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint70_radial_4002_3860",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(20.9949 12.9666) rotate(-117.848) scale(8.91643 7.97074)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.897563,
  stopColor: "#CA9B37",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CA9B37"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint71_linear_4002_3860",
  x1: 16.0688,
  y1: 6.92295,
  x2: 16.7329,
  y2: 8.47578,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FAA719"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DB6008"
})));

function SvgWomanRaisingHand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanRaisingHand);
export default __webpack_public_path__ + "static/media/woman-raising-hand.81dad863.svg";
export { ForwardRef as ReactComponent };